<template>
  <div class="row py-md-5 px-md-5 mb-5">
    <div class="col-12">
      <div class="row justify-content-center">
        <div class="col-md-2 text-center">
          <div class="row">
            <div class="col-12 mt-md-3 text-center">
              <h3 class="mt-md-5 mt-3">Prueba Terman</h3>
            </div>
            <div class="col-12 mb-md-3 text-center">
              <h2 class="mb-md-5 mb-3">Serie {{$route.params.serie}}</h2>
            </div>
          </div>
          <div class="row d-none d-md-block">
            <div class="col-12 mt-3 text-center">
              <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
            </div>
          </div>
        </div>
        <div class="col-md-10">
          <ul class="nav nav-tabs mx-3" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Instrucciones</a>
            </li>
          </ul>
          <div class="tab-content mx-2" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div 
                v-for="instruccion of instrucciones"
                v-if="instruccion.serie==$route.params.serie"
                class="row mt-3">
                <div class="col-12 text-center">
                  <b>Instrucciones</b>
                </div>
                <div class="col-12 mt-3">
                  {{instruccion.instruccion1}}
                </div>
                <div 
                v-if="instruccion.instruccion2.length>0" 
                class="col-12 mt-3">
                  {{instruccion.instruccion2}}
                </div>
                <div class="col-12 mt-3">
                  <b>Seleccionar respuesta:</b>
                </div>
                <div class="col-12 mt-3">
                  1. {{instruccion.seleccionar1}}
                </div>
                <div 
                  v-if="instruccion.seleccionar2.length>0" 
                  class="col-12 mt-3">
                  2. {{instruccion.seleccionar2}}
                </div>
                <div class="col-12 mt-3">
                  <b>Cancelar respuesta:</b>
                </div>
                <div class="col-12 mt-3">
                  1. {{instruccion.cancelar1}}
                </div>
                <div 
                  v-if="instruccion.cancelar2.length>0" 
                  class="col-12 mt-3">
                  2. {{instruccion.cancelar2}}
                </div>
                <div class="col-12 mt-3">
                  <b>Ejemplo</b>
                </div>
                <div 
                  v-if="
                    $route.params.serie==1
                    ||
                    $route.params.serie==2
                    ||
                    $route.params.serie==7
                    ||
                    $route.params.serie==9
                  "
                  class="col-12 mt-3 border border-secondary">
                  <div 
                    class="row mb-3 justify-content-center"
                    v-if="pregunta.active" 
                    v-for="pregunta of ejemplo.preguntas">
                    <div
                      v-if="$route.params.serie!=9" 
                      class="col-12 mt-3 text-center pl-4">
                      <b>{{pregunta.nompregunta}}</b>
                    </div>
                    <div class="col-12 my-2 ml-2">
                      <div class="row justify-content-center">
                        <div 
                          v-on:click="Seleccionar_Respuesta(pregunta.numero, respuesta.numero)"
                          class="select_respuesta text-center" 
                          :class="{
                            'col-md-2':$route.params.serie==9,
                            'col-md-3':$route.params.serie==1 || $route.params.serie==7 ,
                            'col-md-4':$route.params.serie==2
                          }"
                          v-for="respuesta of pregunta.respuestas">
                          <div class="row mt-3 justify-content-center">
                            <div class="col-2 text-right">
                              <i 
                                v-if="pregunta.respuesta===respuesta.numero" 
                                class="fas fa-sm fa-check" />
                              <i v-else class="far fa-sm fa-square"></i>
                            </div>
                            <div class="col-8 px-0 text-left">
                              {{respuesta.respuesta}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div 
                  v-else-if="
                    $route.params.serie==3
                    ||
                    $route.params.serie==6
                    ||
                    $route.params.serie==8
                  "
                  class="col-12">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col" class="text-center">Palabras</th>
                        <th scope="col" class="text-center">
                          <span v-if="$route.params.serie==3">
                            Igual
                          </span>
                          <span v-if="$route.params.serie==6">
                            Si
                          </span>
                          <span v-if="$route.params.serie==8">
                            Verdadero
                          </span>
                        </th>
                        <th scope="col" class="text-center">
                          <span v-if="$route.params.serie==3">
                            Opuesto
                          </span>
                          <span v-if="$route.params.serie==6">
                            No
                          </span>
                          <span v-if="$route.params.serie==8">
                            Falso
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody v-for="pregunta of ejemplo.preguntas" v-if="pregunta.active">
                      <tr>
                        <th scope="row">{{pregunta.numero}}</th>
                        <td class="text-center">{{pregunta.nompregunta}}</td>
                        <td 
                          v-on:click="Seleccionar_Respuesta(pregunta.numero,1)" 
                          class="text-center">
                          <i 
                            v-if="pregunta.respuesta==1" 
                            class="fas fa-check" />
                        </td>
                        <td 
                          v-on:click="Seleccionar_Respuesta(pregunta.numero,2)" 
                          class="text-center">
                          <i 
                            v-if="pregunta.respuesta==2" 
                            class="fas fa-check" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div 
                  v-if="
                    $route.params.serie==4
                  "
                  class="col-12 px-0 mt-3 border border-secondary">
                  <div 
                    class="row mb-3 justify-content-center"
                    v-if="pregunta.active" 
                    v-for="pregunta of ejemplo.preguntas">
                    <div 
                      class="col-12 mt-3 text-center pl-4">
                      <b>{{pregunta.nompregunta}}</b>
                    </div>
                    <div class="col-12 my-2 ml-2">
                      <div class="row justify-content-center">
                        <div
                          v-on:click="Seleccionar_Respuesta(pregunta.numero, respuesta.numero)"
                          class="col-2 select_respuesta text-center"
                          v-for="respuesta of pregunta.respuestas">
                          <div class="row mt-3 justify-content-center">
                            <div class="col-2 text-right">
                              <i 
                                v-if="pregunta.respuesta.indexOf(respuesta.numero)>=0" 
                                class="fas fa-sm fa-check" />
                              <i v-else class="far fa-sm fa-square"></i>
                            </div>
                            <div class="col-8 px-0 text-left">
                              {{respuesta.respuesta}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div 
                  v-else-if="
                    $route.params.serie==5
                    ||
                    $route.params.serie==10
                  "
                  class="col-12">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col" class="text-center">Pregunta</th>
                        <th 
                          v-if="$route.params.serie==5" 
                          scope="col" 
                          class="text-center">
                          Respuesta
                        </th>
                        <th 
                          v-else
                          scope="col"
                          colspan="2" 
                          class="text-center">
                          Respuestas
                        </th>
                      </tr>
                    </thead>
                    <tbody v-for="pregunta of ejemplo.preguntas" v-if="pregunta.active">
                      <tr>
                        <th scope="row">{{pregunta.numero}}</th>
                        <td class="text-left">{{pregunta.nompregunta}}</td>
                        <td class="text-center">
                          <div class="row">
                            <div class="form-group col-12">
                              <input 
                                type="number"
                                v-model="pregunta.respuesta"
                                class="form-control">
                            </div>
                          </div>
                        </td>
                        <td 
                          v-if="$route.params.serie==10"
                          class="text-center">
                          <div class="row">
                            <div class="form-group col-12">
                              <input 
                                type="number"
                                v-model="pregunta.respuesta2"
                                class="form-control">
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5 text-center d-block d-md-none">
          <button class="btn btn-lg btn-primary" v-on:click="Iniciar_Examen">Iniciar <i class="fas fa-arrow-circle-right"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      instrucciones:[
        {
          serie:1,
          instruccion1:'A continuación aparecerá una serie de oraciones con cuatro alternativas de las cuales deberá de elegir sólo una de ellas.',
          instruccion2:'Seleccione la alternativa que contenga la respuesta que complete correctamente la oración, como se muestra en el siguiente ejemplo.',
          seleccionar1:'Posicione la flecha del mouse sobre el texto de la respuesta deseada',
          seleccionar2:'Presione el botón izquierdo del mouse para marcar la respuesta',
          cancelar1:'Posicione la flecha del mouse en la respuesta a cancelar',
          cancelar2:'Presione el botón izquierdo del mouse para quitar la marca a la respuesta',
        },
        {
          serie:2,
          instruccion1:'A continuación aparecerá una serie de oraciones con tres alternativas de las cuales deberá de elegir sólo una de ellas.',
          instruccion2:'Seleccione la alternativa que contenga la respuesta que complete correctamente la oración, como se muestra en el siguiente ejemplo.',
          seleccionar1:'Posicione la flecha del mouse sobre el texto de la respuesta deseada',
          seleccionar2:'Presione el botón izquierdo del mouse para marcar la respuesta',
          cancelar1:'Posicione la flecha del mouse en la respuesta a cancelar',
          cancelar2:'Presione el botón izquierdo del mouse para quitar la marca a la respuesta',
        },
        {
          serie:3,
          instruccion1:'A continuación aparecerá una serie de palabras las cuales son mostradas en pares, cuando las dos palabras signifiquen lo MISMO, seleccione su casilla correspondiente que se encuentra en la columna que tiene como título "igual", cuando signifiquen lo CONTRARIO, seleccione su casilla correspondiente que se encuentra en la columna que tiene como titulo "opuesto".',
          instruccion2:'',
          seleccionar1:'Posicione la flecha del mouse sobre el texto de la respuesta deseada',
          seleccionar2:'Presione el botón izquierdo del mouse para marcar la respuesta',
          cancelar1:'Posicione la flecha del mouse en la respuesta a cancelar',
          cancelar2:'Presione el botón izquierdo del mouse para quitar la marca a la respuesta',
        },
        {
          serie:4,
          instruccion1:'A continuación aparecerá una serie de oraciones con cinco alternativas de las cuales se deberán de elegir DOS de ellas.',
          instruccion2:'Seleccione las alternativas que contengan las DOS palabras que indican algo que SIEMPRE tiene el sujeto, como se muestra en el siguiente ejemplo.',
          seleccionar1:'Posicione la flecha del mouse sobre el texto de la respuesta deseada',
          seleccionar2:'Presione el botón izquierdo del mouse para marcar la respuesta',
          cancelar1:'Posicione la flecha del mouse en la respuesta a cancelar',
          cancelar2:'Presione el botón izquierdo del mouse para quitar la marca a la respuesta',
        },
        {
          serie:5,
          instruccion1:'A continuación aparecerá una serie de ejercicios los cuáles deberá resolver rápidamente. Encuentre las respuestas lo más pronto posible escríbalas en el espacio en blanco que se proporciona, como se muestra en el ejemplo.',
          instruccion2:'',
          seleccionar1:'Posicione la flecha del mouse en la caja de texto que se encuentra al lado de la pregunta, la flecha del mouse toma la forma de l. Presione el botón izquiero del mouse para poder posicionarse dentro de la caja de respuestas y poder introducir el valor deseado.',
          seleccionar2:'',
          cancelar1:'Posicionar la flecha del mouse en la caja de respuestas situada al lado de la pregunta correspondiente a corregir, la flecha del mouse toma la forma de l. Presionar el botón izquierdo del mouse para posicionarse dentro de la caja de respuestas para escribir el resultado correcto.',
          cancelar2:'',
        },
        {
          serie:6,
          instruccion1:'A continuación aparecerá una serie de preguntas con dos posibles respuestas de las cuales deberá de elegir sólo una.',
          instruccion2:'Cuando la respuesta sea afirmativa, seleccione su casilla correspondiente que se encuentra en la columna que tiene como título "Si", en caso contrario seleccione su casilla correspondiente que se encuentra en la columna que tiene como título "No".',
          seleccionar1:'Posicione la flecha del mouse sobre el texto de la respuesta deseada',
          seleccionar2:'Presione el botón izquierdo del mouse para marcar la respuesta',
          cancelar1:'Posicione la flecha del mouse en la respuesta a cancelar',
          cancelar2:'Presione el botón izquierdo del mouse para quitar la marca a la respuesta',
        },
        {
          serie:7,
          instruccion1:'A continuación aparecerá una serie de oraciones con cuatro alternativas de las cuales deberá de elegir sólo una de ellas. ',
          instruccion2:'Selecciona la alternativa que contenga la respuesta que complete correctamente la frase, como se muestra en el siguiente ejemplo.',
          seleccionar1:'Posicione la flecha del mouse sobre el texto de la respuesta deseada',
          seleccionar2:'Presione el botón izquierdo del mouse para marcar la respuesta',
          cancelar1:'Posicione la flecha del mouse en la respuesta a cancelar',
          cancelar2:'Presione el botón izquierdo del mouse para quitar la marca a la respuesta',
        },
        {
          serie:8,
          instruccion1:'Las palabras de cada una de las oraciones siguientes están mezcladas. Ordene cada una de las oraciones.',
          instruccion2:'Si el significado de la oración es VERDADERO, seleccione su respuesta correspondiente que se encuentra en la columna que tiene como título VERDADERO, en caso contrario seleccione su respuesta correspondiente que se encuentra en la columna que tiene como título FLASO como se muestra en el ejemplo.',
          seleccionar1:'Posicione la flecha del mouse sobre el texto de la respuesta deseada',
          seleccionar2:'Presione el botón izquierdo del mouse para marcar la respuesta',
          cancelar1:'Posicione la flecha del mouse en la respuesta a cancelar',
          cancelar2:'Presione el botón izquierdo del mouse para quitar la marca a la respuesta',
        },
        {
          serie:9,
          instruccion1:'A continuación aparecerá una serie de oraciones con cinco alternativas de las cuales deberá de elegir sólo una de ellas.',
          instruccion2:'Selecciona la palabra que NO corresponda con el resto de las palabras que se incluyen en el renglón, como se muestra en el siguiente ejemplo.',
          seleccionar1:'Posicione la flecha del mouse sobre el texto de la respuesta deseada',
          seleccionar2:'Presione el botón izquierdo del mouse para marcar la respuesta',
          cancelar1:'Posicione la flecha del mouse en la respuesta a cancelar',
          cancelar2:'Presione el botón izquierdo del mouse para quitar la marca a la respuesta',
        },
        {
          serie:10,
          instruccion1:'A continuación aparecerán una serie de números.',
          instruccion2:'En cada renglón procure encontrar cómo están hechas las series, después, escriba lo DOS números que deban seguir en cada serie, como se muestra en los ejemplos.',
          seleccionar1:'Posicione la flecha del mouse en la caja de texto que se encuentra al lado de la serie, la flecha del mouse toma la forma l. Presione el botón izquierdo del mouse para poder posicionarse dentro de la caja de respuestas y poder introducir el valor deseado.',
          seleccionar2:'Después de haber introducido el primer valor, para poder posicionarse en la siguiente caja de respuestas se puede proceder de la misma forma como se ha comentado anteriormente, otra manera de hacerlo es presionando la tecla TAB, la cuál permite desplazarse entre las cajas de respuestas.',
          cancelar1:'Posicionar la flecha del mouse en la caja de respuestas situada al lado de la serie correspondeiente a corregir, la flecha del mouse toma la forma de l. Presionar el botón izquierdo del mouse para posicionarse dentor de la caja de respuestas para escribir el resultado correcto.',
          cancelar2:''
        },
      ],
      ejemplo:{
        preguntas:[]
      },
      preguntas1:[
        {
          "nompregunta":"La gasolina se extrae de",
          "numero":"1",
          "respuestas":[
            {"numero":"1","respuesta":"granos"},
            {"numero":"2","respuesta":"petroleo"},
            {"numero":"3","respuesta":"trementina"},
            {"numero":"4","respuesta":"semilla"}],
          "active":true,
          "respuesta":null
        }
      ],
      preguntas2:[
        {
          "nompregunta": "Si la Tierra estuviera más cerca del Sol:",
          "numero": "1",
          "respuestas": [
              {
                  "numero": "1",
                  "respuesta": "las estrellas desaparecerían"
              },
              {
                  "numero": "2",
                  "respuesta": "los meses serían más largos"
              },
              {
                  "numero": "3",
                  "respuesta": "la Tierra estaría más caliente"
              }
          ],
          "active": true,
          "respuesta": null
        }
      ],
      preguntas3:[
        {
          "nompregunta": "salado - dulce",
          "numero": "1",
          "respuesta": null,
          "active": true
        }
      ],
      preguntas4:[
        {
            "nompregunta": "Un CIRCULO tiene siempre:",
            "numero": "1",
            "respuestas": [
                {
                    "numero": "1",
                    "respuesta": "altura"
                },
                {
                    "numero": "2",
                    "respuesta": "circunferencia"
                },
                {
                    "numero": "3",
                    "respuesta": "latitud"
                },
                {
                    "numero": "4",
                    "respuesta": "longitud"
                },
                {
                    "numero": "5",
                    "respuesta": "radio"
                }
            ],
            "active": true,
            "respuesta": []
        }
      ],
      preguntas5:[
        {
            "nompregunta": "A 2 por 5 pesos ¿Cuántos lápices pueden comprarse con 50 pesos?",
            "numero": "1",
            "respuesta": null,
            "active": true
        }
      ],
      preguntas6:[
        {
          "nompregunta": "La higiene es esencial para la salud.",
          "numero": "1",
          "respuesta": null,
          "active": true
        }
      ],
      preguntas7:[
        {
          "nompregunta": "ABRIGO es a USAR como PAN es a:",
          "numero": "1",
          "respuestas": [
              {
                  "numero": "1",
                  "respuesta": "comer"
              },
              {
                  "numero": "2",
                  "respuesta": "hambre"
              },
              {
                  "numero": "3",
                  "respuesta": "agua"
              },
              {
                  "numero": "4",
                  "respuesta": "cocinar"
              }
          ],
          "active": true,
          "respuesta": null
        }
      ],
      preguntas8:[
      {
                "nompregunta": "con crecen los niños edad la",
                "numero": "1",
                "respuesta": null,
                "active": true
            }
      ],
      preguntas9:[
        {
          "nompregunta": "",
          "numero": "1",
          "respuestas": [
              {
                  "numero": "1",
                  "respuesta": "saltar"
              },
              {
                  "numero": "2",
                  "respuesta": "correr"
              },
              {
                  "numero": "3",
                  "respuesta": "brincar"
              },
              {
                  "numero": "4",
                  "respuesta": "pararse"
              },
              {
                  "numero": "5",
                  "respuesta": "caminar"
              }
          ],
          "active": true,
          "respuesta": null
        }
      ],
      preguntas10:[
        {
          "nompregunta": "8, 7, 6, 5, 4, 3,",
          "numero": "1",
          "active": true,
          "respuesta1": null,
          "respuesta2": null
        }
      ]
    }
  },
  methods:{
    Seleccionar_Respuesta(numero_pregunta,numero){
      var posicion=-1;
      for (var i = 0; i < this.ejemplo.preguntas.length; i++) {
        if (this.ejemplo.preguntas[i].numero==numero_pregunta) {
          if (this.$route.params.serie==4) {
            posicion = this.ejemplo.preguntas[i].respuesta.indexOf(numero);
            if(posicion>=0){
              this.ejemplo.preguntas[i].respuesta.splice(posicion,1);
            }else{
              if (this.ejemplo.preguntas[i].respuesta.length<2) {
                this.ejemplo.preguntas[i].respuesta.push(numero);
              }
            }
          }else{
            if (this.ejemplo.preguntas[i].respuesta==numero) {
              this.ejemplo.preguntas[i].respuesta=null;
            }else{
              this.ejemplo.preguntas[i].respuesta=numero;
            }
          }
        }
      }
    },
    Iniciar_Examen(){
      this.$router.push({
        name:'terman_preguntas',
        serie:this.$route.params.serie
      });
    },
    Cargando(){
      this.loading='';
      this.result='d-none';
    },
    Listo(){
      this.loading='d-none';
      this.result='';
    }
  },
  created(){
    switch(this.$route.params.serie){
      case 1:
        this.ejemplo.preguntas=this.preguntas1;
      break;
      case 2:
        this.ejemplo.preguntas=this.preguntas2;
      break;
      case 3:
        this.ejemplo.preguntas=this.preguntas3;
      break;
      case 4:
        this.ejemplo.preguntas=this.preguntas4;
      break;
      case 5:
        this.ejemplo.preguntas=this.preguntas5;
      break;
      case 6:
        this.ejemplo.preguntas=this.preguntas6;
      break;
      case 7:
        this.ejemplo.preguntas=this.preguntas7;
      break;
      case 8:
        this.ejemplo.preguntas=this.preguntas8;
      break;
      case 9:
        this.ejemplo.preguntas=this.preguntas9;
      break;
      case 10:
        this.ejemplo.preguntas=this.preguntas10;
      break;
    }
  }
};
</script>

<style>
.select_respuesta{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Examenes/Terman/Instrucciones.vue